export interface RawCategoryApiResponse {
  id: string;
  catalog_key: string;
  category_key: string;
  category_name: string;
  parent_category_key?: string | null;
  parent_tree?: CategoryBrief[] | null;
  children_count?: number | null;
  status: CategoryStatus;
  created_at: string;
  updated_at: string;
}

export enum CategoryStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface CategoryBrief {
  category_key: string;
  category_name: string;
}

export interface RawCategoryApiCreateRequest {
  category_key: string;
  category_name: string;
  parent_category_key: string;
}

export type CategoryStack = RawCategoryApiResponse[];

export function getFlattenCategoryCombinedName(stack: CategoryStack | undefined) {
  return (stack || [])
    .map((item) => item.category_name)
    .reverse()
    .join(' › ');
}

export function getFlattenCategoryCombinedKey(stack: CategoryStack | undefined) {
  return (stack || []).map((item) => item.category_key).join(',');
}

export function getFlattenCategoryKey(stack: CategoryStack | undefined) {
  if (!Array.isArray(stack) || stack.length === 0) {
    return undefined;
  }
  return stack[0].category_key;
}

export function getFlattenCategoryRoot(stack: CategoryStack | undefined) {
  if (!Array.isArray(stack) || stack.length === 0) {
    return undefined;
  }
  return stack[0];
}

export function sortFlattenCategories(a: CategoryStack, b: CategoryStack) {
  const aReversed = a.slice().reverse();
  const bReversed = b.slice().reverse();

  if (aReversed.length < bReversed.length) {
    return sortHigherAndLowerLevel(aReversed, bReversed);
  }

  if (aReversed.length > bReversed.length) {
    return sortLowerAndHigherLevel(aReversed, bReversed);
  }

  if (!aReversed.length || !bReversed.length) {
    return 0;
  }

  return sortSameLevel(aReversed, bReversed);
}

function sortHigherAndLowerLevel(higher: CategoryStack, lower: CategoryStack) {
  for (let i = 0; i < higher.length; i++) {
    if (higher[i].category_key !== lower[i].category_key) {
      return sortAlphanumerically(higher[i].category_name, lower[i].category_name);
    }
  }

  return -1;
}

function sortLowerAndHigherLevel(lower: CategoryStack, higher: CategoryStack) {
  for (let i = 0; i < higher.length; i++) {
    if (higher[i].category_key !== lower[i].category_key) {
      return sortAlphanumerically(lower[i].category_name, higher[i].category_name);
    }
  }

  return 1;
}

function sortSameLevel(a: CategoryStack, b: CategoryStack) {
  if (a.length === 1) {
    return sortAlphanumerically(a[0].category_name, b[0].category_name);
  }

  for (let i = 0; i < a.length; i++) {
    if (a[i].category_key !== b[i].category_key) {
      return sortAlphanumerically(a[i].category_name, b[i].category_name);
    }
  }

  return 0;
}

function sortAlphanumerically(a: string, b: string) {
  if (a < b) {
    return -1;
  }

  if (a > b) {
    return 1;
  }

  return 0;
}
